var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M46.857 4.769a1.5 1.5 0 01.374 2.088L22.896 41.814c-1.994 2.866-6.12 3.171-8.516.63L.91 28.155a1.5 1.5 0 112.182-2.058l13.473 14.29a2.5 2.5 0 003.87-.286L44.77 5.143a1.5 1.5 0 012.088-.374z"}));
}

Check.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Check;

Check.default = Check;
